import React from "react";
import { Form } from "react-crud-form";
import { FormField, FormItem, FormMessage } from "ui/components/form";
import { Input } from "ui/components/input";
import { Label } from "ui/components/label";
import { useNavigate } from "react-router-dom";
import SelectName from "components/select/name";
import { costMasterSchema } from "./schema";
import { FormActions } from "components/form/actions";
import { useCostMasterForm } from "./useCostMasterForm";
import { PermissionControlledInput } from "permissions/components/input";
import { FormLabel } from "components/form";

const CostMasterForm = ({ costmasterId }) => {
  const navigate = useNavigate();
  const { form, handleCreate, handleUpdate, handleRead } = useCostMasterForm({
    costmasterId,
  });

  return (
    <Form
      form={form}
      create={handleCreate}
      read={handleRead}
      update={handleUpdate}
      itemId={costmasterId || "+"}
      schema={costMasterSchema}
    >
      {({
        isCreating,
        createItem,
        isNewItem,
        isUpdating,
        updateItem,
        isDirty,
      }) => (
        <div className="space-y-6">
          {/* Department */}
          <FormField
            control={form.control}
            name="department"
            render={({ field }) => (
              <FormItem>
                <PermissionControlledInput
                  rule={isNewItem ? "create:*" : "update:*"}
                  collection="cost_master"
                  type="form"
                >
                  <FormLabel>Department</FormLabel>
                  <SelectName
                    collection="departments"
                    fetchItems={true}
                    onValueChange={(val) => field.onChange(val)}
                    {...field}
                  />
                </PermissionControlledInput>
                <FormMessage />
              </FormItem>
            )}
          />

          {/* Grade */}
          <FormField
            control={form.control}
            name="grade"
            render={({ field }) => (
              <FormItem>
                <PermissionControlledInput
                  rule={isNewItem ? "create:*" : "update:*"}
                  collection="cost_master"
                  type="form"
                >
                  <FormLabel>Grade</FormLabel>
                  <SelectName
                    collection="grades"
                    fetchItems={true}
                    onValueChange={(val) => field.onChange(val)}
                    {...field}
                  />
                </PermissionControlledInput>
                <FormMessage />
              </FormItem>
            )}
          />

          {/* Hourly Cost */}
          <FormField
            control={form.control}
            name="hourly_cost"
            render={({ field }) => (
              <FormItem>
                <PermissionControlledInput
                  rule={isNewItem ? "create:*" : "update:*"}
                  collection="cost_master"
                  type="form"
                >
                  <FormLabel>Hourly Cost</FormLabel>
                  <Input
                    type="number"
                    step="0.01"
                    inputMode="decimal"
                    value={field.value ?? ""}
                    onChange={(e) =>
                      field.onChange(
                        e.target.value === ""
                          ? undefined
                          : parseFloat(e.target.value),
                      )
                    }
                  />
                </PermissionControlledInput>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormActions
            isNewItem={isNewItem}
            isCreating={isCreating}
            isUpdating={isUpdating}
            isDirty={isDirty}
            createItem={() => createItem().then(() => navigate(-1))}
            updateItem={() => updateItem().then(() => navigate(-1))}
            showCancel={false}
            collection="cost_master"
            rule={isNewItem ? "create:*" : "update:*"}
          />
        </div>
      )}
    </Form>
  );
};

export default CostMasterForm;
